module.exports = __webpack_public_path__ + "static/media/overlaid-background.b8966d30.svg";